'use client'
// import { getSocket } from '@/socket'
import { useAccountStore } from '@/store'
import { useEffect, useState } from 'react'
import { TOnlineUser } from '../types'

const CLIENT_ID = process.env.NEXT_PUBLIC_SOCKET_CLIENT_ID
const FAKE_USER: TOnlineUser[] = [
  {
    avatar: 'https://mona.media/wp-content/uploads/2023/08/avt-1.jpg',
    email: 'user1@example.com',
    lastname: 'Nguyen',
    id: '1',
    activity: 'Đang xem sản phẩm A',
    is_guest: false,
    socketId: 'socket1',
    itMe: false,
  },
]
export const useOnlineUsers = () => {
  const [onlineUsers, setOnlineUsers] = useState<TOnlineUser[]>(FAKE_USER)
  const { data } = useAccountStore()

  useEffect(() => {
    // const socket = getSocket()
    // // socket.emit('login', CLIENT_ID)
    // // socket.emit('send-active-now', CLIENT_ID)
    // const onUserOnline = (data: { data: TOnlineUser[] }) => {
    //   if (typeof data !== 'object' || !Array.isArray(data.data)) {
    //     console.error('Invalid data format received:', data)
    //     return
    //   }
    //   let currentSessionId = sessionStorage.getItem('sessionId')
    //   const listUsser = data?.data?.map((user) => {
    //     if (user?.id == currentSessionId) {
    //       return {
    //         ...user,
    //         itMe: true,
    //       }
    //     } else {
    //       return user
    //     }
    //   })
    //   setOnlineUsers(listUsser)
    // }
    // socket.on('active-now', onUserOnline)
    // return () => {
    // }
  }, [])

  return {
    onlineUsers: onlineUsers.sort((a, b) => {
      // Nếu a làdataUser?.emailthì đưa lên trước
      if (a.email === data?.email) return -1
      // Nếu b làdataUser?.emailthì đưa b lên trước (a xuống dưới)
      if (b.email === data?.email) return 1
      // Nếu không phải email ưu tiên, sắp theo timestamp giảm dần
      // Nếu không có timestamp (undefined), coi như = 0
      const timestampA = a.timestamp || 0
      const timestampB = b.timestamp || 0

      return timestampB - timestampA
    }),
    setOnlineUsers,
  }
}
